import React from "react";

type TramiteButtonProps = {
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  alert?: boolean;
  badgeCount?: number;
};

const TramiteButton: React.FC<TramiteButtonProps> = ({
  label,
  icon,
  onClick,
  className = "",
  alert = false,
  badgeCount = 1,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
          className={`relative w-full h-40 flex flex-col items-center justify-center rounded-2xl border border-gray bg-gray dark:bg-boxdark-2 p-4 shadow-sm ${className}`}
    >
      {/* Badge */}
      {alert && (
        <span className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1">
          {badgeCount}
        </span>
      )}

        {/* Icon */}
        <div className="rounded-full p-5 bg-white">
            <div className="text-primario-celeste-800 text-[24px]">
                {icon}
            </div>
        </div>
      

      {/* Label */}
          <div className="mt-2 text-sm text-center md:text-title-sm text-textPrimary dark:text-white">
        {label}
      </div>
    </button>
  );
};

export default TramiteButton;